/**
 * FP3-035B-3 — Provider Service Fidelity page.
 * Thin wrapper around the shared `<ServiceFidelityOverview mode="provider" />`.
 * Lives at /reports/service-fidelity. Backend pre-filters to the
 * caller's direct-service caseload.
 */
import ServiceFidelityOverview from "@/components/reports/ServiceFidelityOverview";

export default function ProviderServiceFidelity() {
  return <ServiceFidelityOverview mode="provider" />;
}
